var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lang && _vm.cities_list_event
    ? _c("div", { staticClass: "cities-seo-list" }, [
        _vm.cities_list_event.length != 0
          ? _c(
              "div",
              [
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm._f("capitalize")(_vm.lang.title.cities_list)) +
                      ":"
                  )
                ]),
                _vm._v(" "),
                _vm._l(_vm.cities_list_event, function(city) {
                  return _c("span", { key: city.id }, [
                    _c("a", { attrs: { href: city.url } }, [
                      _vm._v(_vm._s(city.title))
                    ])
                  ])
                })
              ],
              2
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }